import { currentTheme } from '../../themes/themes';
import { Color } from '../helpers/colors';
import { TpZoomPanelCoordMapper } from './zoomPanCanvasHelpers';

export interface TpRectangleSelection {
  logicXMin: number;
  logicYMin: number;
  logicXMax: number;
  logicYMax: number;
}

export interface TpLassoSelection {
  logicPoints: { x: number; y: number }[];
}

//Describes the basic color schema used to draw a chart
export interface TpChartColorSchema {
  backColor: Color;
  foreColor: Color;
}

export function getDefaultChartColorSchema(): TpChartColorSchema {
  return {
    backColor: currentTheme.colors.background,
    foreColor: currentTheme.colors.text,
  };
}

export function fastDist(x1: number, y1: number, x2: number, y2: number) {
  return Math.abs(x1 - x2) + Math.abs(y1 - y2);
}

export function calcMaxZoomFactor(
  maxZoomAbsolute: number | undefined | null,
  maxZoomRelative: number | undefined | null,
  mapper: TpZoomPanelCoordMapper,
  pixelRatio: number,
) {
  if (!maxZoomAbsolute) return maxZoomRelative;
  const renderRange = Math.abs(mapper.renderMax - mapper.renderMin) / pixelRatio;
  const logicalRange = Math.abs(mapper.logicalRange.rmax - mapper.logicalRange.rmin);
  let maxZoom = (maxZoomAbsolute / renderRange) * logicalRange;
  if (maxZoomRelative && maxZoomRelative < maxZoom) maxZoom = maxZoomRelative;
  return maxZoom;
}

export function getPointsInsideLassoSelection(
  lasso: TpLassoSelection,
  points: { x: number; y: number; id: any }[],
): { x: number; y: number; id: any }[] {
  const selectedPoints: { x: number; y: number; id: any }[] = [];

  for (const tryPoint of points) {
    const x = tryPoint.x;
    const y = tryPoint.y;
    let inside = false;
    for (let i = 0, j = lasso.logicPoints.length - 1; i < lasso.logicPoints.length; j = i++) {
      const xi = lasso.logicPoints[i].x;
      const yi = lasso.logicPoints[i].y;
      const xj = lasso.logicPoints[j].x;
      const yj = lasso.logicPoints[j].y;
      const intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    if (inside) selectedPoints.push(tryPoint);
  }

  return selectedPoints;
}

/**
 * Make sure we don't draw outside our designated render area
 */
export function clipToRenderedRange(
  ctx: CanvasRenderingContext2D,
  mapX: TpZoomPanelCoordMapper,
  mapY: TpZoomPanelCoordMapper,
) {
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(mapX.renderMin, mapY.renderMin);
  ctx.lineTo(mapX.renderMax, mapY.renderMin);
  ctx.lineTo(mapX.renderMax, mapY.renderMax);
  ctx.lineTo(mapX.renderMin, mapY.renderMax);
  ctx.closePath();
  ctx.clip();
}
